import { Injectable } from '@angular/core';
import { SpectrogramApiService } from './spectrogram.api.service';
import { Observable } from 'rxjs/Observable';

import { SpectrogramData } from '../../models/spectrogramData';

@Injectable()
export class SpectrogramDomainService {
    constructor(private spectrogramApiService: SpectrogramApiService) {
    }

    getSpectrogramData(jobId: string, date: Date): Observable<{} | SpectrogramData> {
        return this.spectrogramApiService.getSpectrogramData(jobId, date);
    }

    getSpectrogramCsv(jobId: string, dates: Date[], filename: string): void {
        return this.spectrogramApiService.getSpectrogramCsv(jobId, dates, filename);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/services/spectrogram/spectrogram.domain.service.ts